import {useDispatch} from "react-redux";
import {logOut} from "../actions";

const useLogOut = () => {
    const dispatch = useDispatch();
    return () => dispatch(logOut());
}

export default useLogOut;